export default __webpack_public_path__ + "static/media/IV_Old_Black.eefc97cc.png";